<template>
    <div>
        <InfoAlert :showDismissibleAlert="showDismissibleAlert" v-on:close="showDismissibleAlert=false" :info="info" />
        <div class="py-0">
          
          <v-form
    ref="parameterForm"
    v-model="valid" >
      <v-card :color="$store.getters.getColorPalette(). backgroundColorCode" :dark="$store.getters.getColorPalette().isDark">
        <v-card-title  class="headline">
        {{ $store.getters.getTextMap().add_OPC_parameter}}
        </v-card-title>
        <v-card-text>
            <v-container fluid>
                <v-row>
                    <v-col>
                      <v-skeleton-loader
        v-if="loading"
      class="mx-auto"
      type="text"
    ></v-skeleton-loader>
            <v-text-field 
            v-if="!loading"
      v-model="form.name"
      :counter="45"
      :rules="nameRules"
      :label="$store.getters.getTextMap().name"
      required
    ></v-text-field>
                    </v-col>
                    
 <v-col>
   <v-skeleton-loader
        v-if="loading"
      class="mx-auto"
      type="text"
    ></v-skeleton-loader>
                        <v-text-field 
                        v-if="!loading"
                        v-model="form.unit"
                        :counter="5"
                        
                        :label="$store.getters.getTextMap().unit"
                        required>

                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    
                   
                    
                    <v-col>
                      <v-skeleton-loader
        v-if="loading"
      class="mx-auto"
      type="text"
    ></v-skeleton-loader>
                        <v-text-field 
                        v-if="!loading"
                        v-model="form.correction_factor"
                        :counter="8"
                        :rules="positiveFloatRules"
                        :label="$store.getters.getTextMap().correction_factor"
                        required>

                        </v-text-field>
                    </v-col>
                    <v-col>
                      <v-skeleton-loader
        v-if="loading"
      class="mx-auto"
      type="text"
    ></v-skeleton-loader>
                        <v-text-field 
                        v-if="!loading"
                        v-model="form.addition_const"
                        :counter="8"
                        :rules="floatRules"
                        :label="$store.getters.getTextMap().addition_const"
                        required>

                        </v-text-field>
                    </v-col>

                     <v-col>
                       <v-skeleton-loader
        v-if="loading"
      class="mx-auto"
      type="text"
    ></v-skeleton-loader>
                        <v-select 
                        v-if="!loading"
          v-model="form.latency"
          :items="latency"
          item-text="label"
          item-value="value"
          :label="$store.getters.getTextMap().idle_latency"
         :rules="selectRules"
         required
          
          clearable
          
        ></v-select>
                    </v-col>
                    <v-col>
                      <v-skeleton-loader
        v-if="loading"
      class="mx-auto"
      type="text"
    ></v-skeleton-loader>
                        <v-text-field 
                        v-if="!loading"
                        v-model="form.entropy"
                        :counter="6"
                        :rules="positiveFloatRules"
                        :label="$store.getters.getTextMap().entropy"
                        required>

                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                   
                    <v-col>
                      <v-skeleton-loader
        v-if="loading"
      class="mx-auto"
      type="text"
    ></v-skeleton-loader>
                        <v-text-field 
                        v-if="!loading"
      v-model="form.node_id"
      :counter="200"
      :rules="textIDRules"
      :label="$store.getters.getTextMap().node_id"
      required
    ></v-text-field>
                    </v-col>
                  <v-col>
                    <v-skeleton-loader
        v-if="loading"
      class="mx-auto"
      type="text"
    ></v-skeleton-loader>
                        <v-select 
                        v-if="!loading"
          v-model="form.processing"
          :items="processing"
          item-text="label"
          item-value="value"
          :label="$store.getters.getTextMap().data_processing"
         :rules="selectRules"
         required
          
          clearable
          
        ></v-select>
                    </v-col>
                  <v-col>
                    <v-skeleton-loader
        v-if="loading"
      class="mx-auto"
      type="text"
    ></v-skeleton-loader>
                        <v-select
                        v-if="!loading"
          v-model="form.data_type"
          :items="dataTypes"
          item-text="label"
          item-value="value"
          :label="$store.getters.getTextMap().data_type"
         :rules="selectRules"
         required
          
          clearable
          
        ></v-select>
                    </v-col>
             
                </v-row>
    </v-container>
        </v-card-text>
        <v-card-actions>
          <v-checkbox 
          v-if="!loading"
      v-model="form.engineer_access_only"
      :label="$store.getters.getTextMap().restrict_user_access"
    ></v-checkbox>
          <v-checkbox
          v-if="!loading"
      v-model="form.aliasing"
      :label="$store.getters.getTextMap().aliasing"
    ></v-checkbox>
          <v-spacer></v-spacer>
          <v-skeleton-loader
        v-if="loading"
      class="mx-auto"
      type="text"
    ></v-skeleton-loader>
    
          <v-btn
          v-if="!loading"
            :color="$store.getters.getColorPalette().submitbtnColor"
            text
            @click="onSubmit"
          >
           {{edit?$store.getters.getTextMap().update:$store.getters.getTextMap().create}}
          </v-btn>
          <v-btn
            :color="$store.getters.getColorPalette().submitbtnColor"
            text
            @click="onReset"
          >
          {{$store.getters.getTextMap().cancel}}
          </v-btn>
        </v-card-actions>
      </v-card>
      </v-form>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import InfoAlert from '@/components/InfoAlert'
import FormRules from '@/utillities/FormRules'
export default {
    name:'CreateParameter',
    props:['vdevice','param'],
    components:{
        InfoAlert
    },
    mounted(){

      if(this.param && this.param.param_id){
        this.edit=true
        this.api='updateOPCParam'
        this.form=Object.assign({}, this.param)
      }else{
        this.edit=false
        this.api='createOPCParam'
      }

    },
     data(){
        return {
            dialog:false,
            valid:false,
            loading:false,
            edit:true,
            info:'',
            showDismissibleAlert:false,
            api:'createOPCParam',
            byteFormat:['bigEndian','littleEndian'],
            latency:[
                {label:'5 minutes',value:300},
                {label:'15 minutes',value:900},
                {label:'Half hourly',value:1800},
                {label:'Hourly',value:3600},
                {label:'Quarter Day',value:21600},
                {label:'Half Day',value:43200},
                {label:'Daily',value:86400}                
            ],
            processing:[
              {label:'Average',value:'mean'},
                {label:'Difference',value:'difference'}
            ],
            registerSize:[
              {label:'short',value:'short'},
              {label:'long',value:'long'}
            ],
            nameRules: [
        v => !!v || 'Name is required',
        v => /\S+/.test(v) || 'Name is required',
        v => (v && v.length <= 45 && v.length > 0) || 'Name must be less than 45 characters',
      ],
      unitRules:[
          v => !!v || 'Unit is required',
        v => /\S+/.test(v) || 'Unit is required',
        v => (v && v.length <= 5) || 'Unit length is invalid'
      ],
      numberRules:[
          v => !!v || 'Required',
          v => /[0-9]+$/.test(v) || 'It should be a number',
          v => (v && v>0 && v%1==0)|| 'It should be a valid number',
          v => (v && v.length <= 5 && v.length > 0) || 'Name must be less than 5 digits',
      ],
      positiveFloatRules:[
          v => !!v || 'Required',
          v => (v && !isNaN(Number(v))) || 'It should be a number',
          v => (v && v>0 )|| 'It should be more than zero',
          v => (v && v.length <= 12 && v.length > 0) || 'It must be less than 12 digits',
      ],
      floatRules:[
          v => !!v || 'Required',
          v => (v && !isNaN(Number(v))) || 'It should be a number',
          v => (v && v.length <= 12 && v.length > 0) || 'It must be less than 12 digits',
      ],
      textIDRules:[FormRules.rules.required, FormRules.rules.nonZeroLengthDynamic(205),],
        msgRules: [
        v => !!v || 'Description is required',
        v => (v && v.length <= 35 && v.length > 0) || 'Description must be less than 205 characters',
      ],
      selectRules:[
        v=> (v!=null) || 'Required'
      ],
      form:{
                byte_format:null,
                correction_factor:null,
                register_size:'short',
                name:null,
                entropy:null,
                latency:3600,
                unit:null,
                command:null,
                address:null,
                offset:null,
                processing:null,
                engineerAccessOnly:false,
                aliasing:false
                
            }
        }
    },
    computed:{
      dataTypes(){
        let op=[]
        if(this.$store.state.dataTypes){
          for(let i of this.$store.state.dataTypes){
            op.push({
              label:i.type,
              value:i.id
            })
          }
        }
        return op
      }
    },
    methods:{
        onSubmit(){
            this.$refs.parameterForm.validate()
            if(this.valid){
              this.loading=true
            //evt.preventDefault()
            //this.form.id=(new Date).getTime().toString()
            let d=Object.assign({}, this.form)
            if(this.edit){
              d.param_id=this.param.param_id
            }else{
              d.device_id=this.vdevice.device_id

            }
            console.log(this.api,d)
            axios.post(this.$store.state.api+this.api,d,{headers: {
      Authorization: 'Bearer '+ this.$store.state.jwt
    }})
    .then(response=>{
      if(response.data.status==='success'){
        //this.$store.commit('addParameter',d)
        this.$store.dispatch('refreshOPCParams')
        //console.log("Parameter added "+d)
        if(this.edit){
          this.$emit('update')
          this.$emit('close')
          this.dialog=false

        }else{

          this.onReset()
        }
            //this.dialog=false
            //this.$emit('close')
    }else{
      //console.log(response.data.msg)
      this.info = response.data.msg;
      //this.info = d;
            this.showDismissibleAlert = true;
      //console.log(response.data.msg)
    }
    this.loading=false
  })
    .catch(err=>{console.log(err)});
                //this.$store.dispatch('addDevice', d)
            
            }
        },
        onReset(){
            //evt.preventDefault()
            /*this.form={
                id:null,
                msg:null,
                name:null
            }*/
            this.$refs.parameterForm.reset()
            this.dialog=false
            this.loading=false
            this.$emit('close')
        }

    }

}
</script>